import { Button, useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { loginUrlReturningTo, onSignedOutDuringSave } from "../redux/redirectToLoginOnExpiredSession";

const NOTICE = "signed-out-during-save";

export const SignedOutDuringSaveNotice = () => {
  const toast = useToast();
  const { t } = useTranslation();

  useEffect(
    () =>
      onSignedOutDuringSave(() => {
        if (toast.isActive(NOTICE)) return;
        toast({
          id: NOTICE,
          status: "warning",
          duration: null,
          isClosable: true,
          title: t("You have been signed out. Your last change was not saved."),
          description: (
            <Button as="a" href={loginUrlReturningTo(window.location)} size="sm" mt="2" colorScheme="teal">
              {t("Log in")}
            </Button>
          ),
        });
      }),
    [toast, t],
  );

  return null;
};
